import angular from "angular";
import camelToKebabFilter from './camelToKebab.filter';

let camelToKebabModule = angular.module('camelToKebab.filter', [])
.filter('camelToKebab', camelToKebabFilter)

.name;

export default camelToKebabModule;



// WEBPACK FOOTER //
// ./client/app/common/filters/camelToKebabService/camelToKebab.js